module.exports = __webpack_public_path__ + "static/media/gpx.f5b0d6e2.png";